import type {CreateExtArgs} from '@wix/document-manager-core'

export const repeaterMetaData = {
    isRepeatable: ({coreConfig}: CreateExtArgs) => coreConfig.experimentInstance.isOpen('dm_repeaterInRepeater'),
    enforceContainerChildLimitsByWidth: false,
    isRepeater: true
}
